module.exports = __webpack_public_path__ + "static/media/img-marca-AoN-edificio-final.192f7499.png";